var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1797,
    height: 764,
    viewBox: "0 0 1797 764",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.69174 51.2051L24.9331 38.7787L43.1092 59.4077L47.3728 33.8294L76.1281 37.5247",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.54 205.675L1714.4 192.632L1733.18 212.767L1736.68 187.085L1765.54 190.011",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M631.404 17.995L657.929 15.3771L665.973 41.1738L680.589 19.3164L705.426 33.5743",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2433 717.995L50.7678 715.377L58.8124 741.174L73.428 719.316L98.2652 733.574",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.74 143.035L1139.16 139.553L1148.13 165.072L1161.95 142.75L1187.28 156.189",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M269.873 156.035L296.287 152.553L305.259 178.072L319.076 155.75L344.414 169.189",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.834 413.961L161.24 403.749L177.212 425.964L184.081 400.903L212.32 407.247",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M562.101 557.338L585.403 545.014L603.477 565.724L607.866 540.164L636.603 543.987",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M562.101 557.338L585.403 545.014L603.477 565.724L607.866 540.164L636.603 543.987",
    stroke: "white",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M886.504 736.035L912.918 732.553L921.89 758.072L935.708 735.75L961.045 749.189",
    stroke: "white",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.93 465.268L1204.52 458.138L1217.33 482.129L1227.55 458.122L1254.69 467.88",
    stroke: "white",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.86 621.398L1387.49 609.653L1404.99 630.801L1410.08 605.359L1438.7 609.888",
    stroke: "white",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1594.68 397.035L1621.1 393.553L1630.07 419.072L1643.89 396.75L1669.22 410.189",
    stroke: "white",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1720.96 701.035L1747.37 697.553L1756.34 723.072L1770.16 700.75L1795.5 714.189",
    stroke: "white",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1516.82 7.03485L1543.23 3.55287L1552.2 29.0719L1566.02 6.75046L1591.36 20.1894",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirds);
export default __webpack_public_path__ + "static/media/birds.b7f0e7b1e1032b9031c4e8c5b6876cc1.svg";
export { ForwardRef as ReactComponent };